// extracted by mini-css-extract-plugin
export default {"logo":"headerLogo_logo__zZ32R"};